import React from 'react';
import Hero from './components/faculty/Hero';
import Main from './components/faculty/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Faculty = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default Faculty;